
export default {
    focus: {
        components: {
            button: {
                back: 'Retour',
                cancel: 'Annuler',
                edit: 'Modifier',
                help: 'Accédez au centre d\'aide en cliquant ici',
                save: 'Enregistrer',
                saving: 'Enregistrement'
            },
            field: {
                required: 'Ce champ est requis'
            },
            modal: {
                confirmation: {
                    cancel: 'Abandonner',
                    confirm: 'Continuer',
                    text: 'Vous êtes sur le point de quitter la fenêtre. Toutes vos modifications seront perdues. Souhaitez-vous continuer ?',
                    title: 'Confirmation'
                }
            },
            input: {
                autocomplete: {
                    error: {
                        invalid: 'Saisie incorrecte'
                    }
                },
                display: {
                    checkbox: {
                        true: 'Oui',
                        false: 'Non'
                    }
                },
                date: {
                    error: {
                        default: 'Saisie incorrecte'
                    },
                    invalid: 'Format {{date}} non valide'
                },
                select: {
                    error: {
                        default: 'Saisie non valide'
                    },
                    noLabel: '-'
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/translation/resources/fr-FR.js